module.exports = __webpack_public_path__ + "static/media/icon-year.0dd9a82a.svg";